import React, { useState } from "react";
import clsx from "clsx";
import { useDropzone } from "react-dropzone";
import { remCalc } from "../../utils/helpers";
import { Trans } from "react-i18next";
// import * as CSV from "../../customizedLibs/csv/csv";
import { setLoadingImport } from "../../store/actions/loading";
import { connect } from "react-redux";

import fileIcon from "../../assets/images/icons/file-upload-icon.svg";
import Typography from "@material-ui/core/Typography/index";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core";

const worker = new Worker("/workers/readExcel.js");

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.darkGrey.main,
    fontSize: 12
  },
  dropZone: {
    height: remCalc(224),
    boxSizing: "border-box",
    borderRadius: 4,
    border: "1px dashed #C2C3C7",
    transition: "border 0.3s, transform 0.2s",
    backgroundColor: "#F7F7F7",
    cursor: "pointer",
    "&:focus": {
      outline: "none",
      borderColor: "rgba(77, 97, 114, 0.5)"
    }
  },
  dropZoneDragging: {
    borderColor: "rgba(77, 97, 114, 0.6)"
  },
  dashedDivider: {
    width: "30%",
    borderTop: "1px dashed #C4C4C4"
  },
  button: {
    // backgroundColor: "#DBDCE1",
    fontWeight: 500,
    textTransform: "none",
    marginTop: theme.spacing(3),
    padding: theme.spacing(1, 4),
    height: remCalc(36)
  }
}));

function DragAndDrop({
  setLoadingImport,
  setLoadingImportLeft,
  handleFetch,
  isUploadingStops,
  setButtonVisible,
  type
}) {
  const classes = useStyles();
  const [error, setError] = useState("");

  setLoadingImport = setLoadingImportLeft || setLoadingImport;

  const onDrop = (acceptedFiles, allFiles) => {
    if (acceptedFiles.length) {
      setLoadingImport(true);
      setError("");
      const dataFile = acceptedFiles[0];
      // CSV
      // if (dataFile.type === "text/csv") {
      // CSV.fetch({
      //   file: dataFile
      // }).then(function (dataset) {
      //   console.log(dataset);
      //   let headerArr = dataset.fields;

      //   const regexpsToMatch = [
      //     /type\*?$/,
      //     /street\*?$/,
      //     /postal_code\*?$/,
      //     /country_code\*?$/
      //   ];

      //   const validFile = regexpsToMatch.every(regexp => {
      //     headerArr.some(header => regexp.test(header?.trim()));
      //   });

      //   console.log(headerArr, validFile);

      //   if (!validFile) {
      //     const reader = new FileReader();
      //     reader.readAsDataURL(dataFile);
      //     reader.onload = () => handleFetch(true, reader.result, "csv");
      //     reader.onerror = console.log;
      //     console.log(dataFile);
      //     return;
      //   }

      //   const jsonData = dataset.records.map(el => {
      //     let data = {};
      //     headerArr.forEach((field, i) => {
      //       const fieldName = field.replace(/\*$/, "");

      //       data[fieldName] = el[i] === null ? null : el[i].toString();
      //     });

      //     return data;
      //   });

      //   handleFetch(jsonData);
      // });
      // XLS
      const reader = new FileReader();
      reader.onload = function (e) {
        worker.postMessage({ msg: "read", d: e.target.result, type });

        const splittedName = dataFile.name.split(".");
        const extension = splittedName[splittedName.length - 1];

        worker.onmessage = msg => workerMessage(msg, extension);
      };

      reader.readAsArrayBuffer(dataFile);
    } else if (allFiles.length > 1) setError("Please upload single file");
    else setError("File type not supported");
  };

  const workerMessage = (e, extension) => {
    if (e && e.data) {
      setButtonVisible && setButtonVisible(true);
      if (e.data.blank) {
        handleFetch({ blank: e.data.blank });
      } else if (e.data.rawData) {
        handleFetch({
          file: btoa(e.data.rawData),
          rawData: e.data.rawData,
          data: e.data.data,
          extension
        });
      } else {
        handleFetch({ body: e.data, rawData: e.data.rawData });
      }
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: ".xls, .xlsx, .csv"
  });

  return (
    <Box className={classes.root} my={0} mx={3}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        className={clsx(classes.dropZone, {
          [classes.dropZoneDragging]: isDragActive
        })}
        {...getRootProps()}
      >
        <input {...getInputProps()} />

        <Box display="flex" alignItems="center" justifyContent="center" mb={3}>
          <Box component="img" src={fileIcon} alt="Upload file" mr={2.5} />

          <Typography variant="body1" style={{ color: "#7D7E82" }}>
            Drag and drop your <br />
            Excel file here
          </Typography>
        </Box>

        {isDragActive ? (
          <>
            <Typography variant="body2">
              <Trans i18nKey="dropHere">Drop here</Trans>
            </Typography>
          </>
        ) : (
          <>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
            >
              <Box className={classes.dashedDivider} mr={1} />

              <Typography
                variant="body2"
                style={{ fontWeight: 500, color: "#7D7E82" }}
              >
                <Trans i18nKey="or">OR</Trans>
              </Typography>

              <Box className={classes.dashedDivider} ml={1} />
            </Box>

            <Button
              className={classes.button}
              color="primary"
              variant="contained"
              disableElevation
              data-cy={`browse-upload${isUploadingStops ? "Stops" : ""}`}
            >
              <Trans i18nKey="browse">Browse</Trans>
            </Button>
          </>
        )}
      </Box>

      {error && (
        <Typography align="center" color="error">
          {error}
        </Typography>
      )}
    </Box>
  );
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { setLoadingImport })(DragAndDrop);
